import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch } from "react-redux";
import Button from "src/components/common/Button";
import styled from "styled-components";
import BottomModal, { RefProps } from "../common/BottomModal";
import SelectCompanyItem from "../filter/SelectCompanyItem";

interface esDetailProps {
  companyId?: string;
  companyName?: string;
  onChange?: any;
  free_yn?: string;
  rejectBoxToFunc?: any;
  visit_date?: string;
}

const RejectionBox = (props: esDetailProps) => {
  const venderModalRef = React.useRef<RefProps>(null);

  const [isFreeCheck, setIsFreeCheck] = useState<boolean>();

  const [thisCompanyName, setThisCompanyName] = useState<string>();
  const [thisCompanyId, setThisCompanyId] = useState<string>();
  const [tempCompanyId, setTempCompanyId] = useState<string>();
  const [tempCompanyName, setTempCompanyName] = useState<string>();
  const [tempIsFree, setTempFree] = useState<boolean>();
  const [isCancelClick, setIsCancelClick] = useState<boolean>();

  const openVenderSelect = () => {
    setIsCancelClick(false);
    if (venderModalRef.current) venderModalRef.current.modalOpen();
  };

  // 확인 버튼
  const selectCompanyComfirm = async (e: React.MouseEvent) => {
    let freeYn = "";
    if (isFreeCheck) {
      freeYn = "Y";
    } else {
      freeYn = "N";
    }
    if (!isEmpty(tempCompanyId)) {
      props.rejectBoxToFunc(tempCompanyId, freeYn);
    } else {
      props.rejectBoxToFunc(props.companyId, freeYn);
    }
    if (!isEmpty(tempCompanyName)) {
      setThisCompanyName(tempCompanyName);
    } else {
      setThisCompanyName(props.companyName);
    }
    if (venderModalRef.current) venderModalRef.current.modalClose();
  };

  // ========================================== 퍼블 영역 ==========================================

  // const reduceCompanyName = useAppSelector((state) => state.asReduce.company_name, shallowEqual);

  // const dispatch = useDispatch();

  useEffect(() => {
    if (!isEmpty(props.free_yn)) {
      if (props.free_yn === "Y") {
        setIsFreeCheck(true);
        setTempFree(true);
      } else {
        setIsFreeCheck(false);
        setTempFree(false);
      }
    }
  }, [props]);

  useEffect(() => {
    setThisCompanyId(props.companyId);
  }, [props.companyId]);

  useEffect(() => {
    setThisCompanyName(props.companyName);
  }, [props.companyName]);

  const freeCheck = (check: boolean) => {
    setIsFreeCheck(!check);
  };

  // 취소 버튼
  const cancelBtn = () => {
    setTempCompanyName(thisCompanyName);
    setTempCompanyId(thisCompanyId);
    setIsFreeCheck(tempIsFree);
    setIsCancelClick(true);
  };

  const selectCompanyItemToFunc = (id: any, name: any) => {
    setTempCompanyId(id);
    setTempCompanyName(name);
  };

  return (
    <>
      <RejectionSet>
        <div>
          <dt>업체정보</dt>
          <dd className="divide">
            <p>{thisCompanyName}</p>
            {isEmpty(props.visit_date) ? (
              <Button variant="outlined" br="round" size="small" onClick={openVenderSelect}>
                변경
              </Button>
            ) : (
              ""
            )}
          </dd>
        </div>
        <div>
          <dt>반려 사유</dt>
          <dd>
            <textarea placeholder="반려 사유입니다." id="cancel_reason" onChange={(e) => props.onChange(e)} />
          </dd>
        </div>
      </RejectionSet>
      <BottomModal
        ref={venderModalRef}
        modalTitle="업체 선택"
        checkBox="무상"
        footerBtn="선택하기"
        checked={isFreeCheck}
        onChange={(children) => freeCheck(children)} // 무상 체크
        onClick2={(e) => selectCompanyComfirm(e)} // 선택하기
        onClick3={(e) => cancelBtn()} // X 닫기
      >
        <SelectCompanyItem selectedCom={thisCompanyId} selectCompanyItemToFunc={selectCompanyItemToFunc} isCancelClick={isCancelClick} />
      </BottomModal>
    </>
  );
};

const RejectionSet = styled.dl`
  margin-bottom: 40px;
  > div + div {
    padding-top: 30px;
    margin-top: 30px;
    border-top: 1px solid ${({ theme }) => theme.color.secondary};
  }
  dt {
    font-size: 16px;
    margin-bottom: 10px;
  }
  dd {
    &.divide {
      ${({ theme }) => theme.flexBox.flexMixin()}
      > p {
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
  textarea {
    width: 100%;
    height: 150px;
    padding: 15px;
    border: none;
    border-radius: 4px;
    resize: none;
    outline: none;
    color: #001827;
    font-family: "Roboto";
    font-weight: 500;
    font-size: 16px;
  }
`;

export default RejectionBox;
